import { render, staticRenderFns } from "./inputController.vue?vue&type=template&id=143896ed&"
import script from "./inputController.vue?vue&type=script&lang=ts&"
export * from "./inputController.vue?vue&type=script&lang=ts&"
import style0 from "./inputController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports